module.exports = __webpack_public_path__ + "img/bear.654bded3.png";